import SJButton from '@/components/SJButton'
import SJCard from '@/components/SJCard'
import { useState, useMemo, useEffect } from 'react'
import { Coupon, OrderAddReq, OrderAddRes, OrderPaysignRes } from '@/services/types/payment'
import { orderAdd, orderPaySign } from '@/services/payment'
// import accredit from '@stores/accredit'
// import SJScreenDialog from '@components/SJScreenDialog'
// import STToast from '@components/STToast'
// import CouponPicker from '@components/CouponPicker'
import { getDevicesName } from '@/services/device'
import { getCourseById } from '@/services/course'
import { Course } from '@/services/types/course'
import { DeviceInfoRes } from '@/services/types/device'
import { useLocation, useNavigate } from 'react-router-dom'
import './index.less'

const CourseOrder = () => {
  document.title = '订单信息'
  const navigate = useNavigate()
  const { state } = useLocation() as { state: { courseId: string; deviceId: string } }
  const { courseId, deviceId } = state
  const [course, setCourse] = useState<Course>() // 课程
  const [device, setDevice] = useState<DeviceInfoRes>() // 选中设备

  useEffect(() => {
    fetchDeviceInfo()
    fetchCourse()
  }, [])

  const fetchDeviceInfo = async () => {
    try {
      const res = (await getDevicesName(deviceId)) as unknown as DeviceInfoRes[]
      console.log(res)
      setDevice(res[0])
    } catch (error) {}
  }

  // 课程信息
  const fetchCourse = async () => {
    try {
      const params = {
        course_id: courseId,
        device_sn: deviceId,
      }
      const res = (await getCourseById(params)) as unknown as Course
      console.log(res)
      setCourse(res)
    } catch (error) {}
  }

  // dialog显示
  // const [visible, setVisible] = useState(false)
  // const onVisibleChange = (val) => {
  //   setVisible(val)
  // }
  // 选择优惠券
  const [coupon] = useState<Coupon>()
  // const handlePickCoupon = (_coupon: Coupon) => {
  //   setVisible(false)
  //   setCoupon(_coupon)
  // }

  const total = useMemo(() => {
    return Number(course?.fee || 0) - (coupon?.couponAmount || 0)
  }, [course, coupon])

  const goPay = async () => {
    if (!course || !deviceId) return
    try {
      const params: OrderAddReq = {
        type: coupon ? 2 : 1, // Y	支付方式（1、现金 2、优惠券 3、混合 优惠券+现金）
        amount: Number(course.fee), // Y	支付金额
        productList: [
          { productCode: course.merchandise_code || '' }, // Y	商品编码
        ], // Y	商品列表
        count: 1, // Y	商品数量
        useCouponCode: coupon?.useCouponCode, // N	优惠券编码
        fullAmount: total, // Y	合计金额
        businessCode: deviceId, // 报名id
      }
      const res = (await orderAdd(params)) as unknown as OrderAddRes
      if (res.orderCode && !coupon) {
        // 只支持微信支付，暂无优惠券
        const ret = (await orderPaySign(res.orderCode)) as unknown as OrderPaysignRes
        console.log(ret)
        // Taro.requestPayment({
        //   ...ret,
        //   success: (s) => {
        //     console.log(s)
        //     Taro.navigateBack()
        //   },
        //   fail: (err) => {
        //     log.error('requestPayment', err)
        //     Taro.reLaunch({
        //       url: `/packageOrder/pages/orderDetail2/index?orderCode=${res.orderCode}`,
        //     })
        //   },
        // })
      } else {
        navigate(-1)
      }
    } catch (error) {}
  }
  return (
    <div className="page accredit-order">
      <div className="main">
        <SJCard className="order-info">
          <div className="order-item">
            <div className="label">课程名称</div>
            <div className="value">{course?.course_name}</div>
          </div>
          <div className="order-item">
            <div className="label">课程费用</div>
            <div className="value">¥{course?.fee}</div>
          </div>
          <div className="order-item">
            <div className="label">所属设备</div>
            <div className="value">{device?.name}</div>
          </div>
          {/* <div className='order-item' hoverClass='hoverClass' onClick={() => setVisible(true)}>
            <div className='label'>优惠券</div>
            <div className='value value-coupon'>{`-${coupon?.couponAmount || 0}`}</div>
          </div> */}
          <div className="order-item">
            <div className="label label-total">总计</div>
            <div className="value">
              ¥<span className="value-total">{total}</span>
            </div>
          </div>
        </SJCard>
      </div>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={goPay}>
          去支付 ¥{total}
        </SJButton>
      </div>
      {/* <SJScreenDialog title='优惠券' visible={visible} onVisibleChange={onVisibleChange}>
        <ScrollView className='coupon-scroll' scrollY showScrollbar={false}>
          <CouponPicker onCouponChange={handlePickCoupon}></CouponPicker>
        </ScrollView>
      </SJScreenDialog> */}
    </div>
  )
}

export default CourseOrder
